<template>
  <b-modal
    id="modal-version"
    scrollable
    title="Novidades da versão"
    :visible="value"
    @change="onChange"
    cancel-title="Fechar"
    :hide-footer="true"
    size="lg"
    body-class="modal-version-body"
  >
    <div class="modal-version-wrapper">
      <iframe
        src="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3871"
        frameborder="0"
        class="modal-version-iframe"
      ></iframe>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'NovidadesDaVersao',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(valor) {
      this.$emit('input', valor)
    },
  },
}
</script>

<style lang="scss">
.modal-version-body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.modal-version-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.modal-version-iframe {
  width: 100%;
  max-width: 900px;
  height: 800px;
  border-radius: 8px;
}
</style>
